import React from 'react'
import CompanysDetails from '../../components/companysdetail/CompanysDetail'

const CompanyDetail = () => {
    return (
        <>
            <CompanysDetails />
        </>
    )
}

export default CompanyDetail
